import { repositoryActionTypes as actionType } from 'src/constants/actionTypes';
import repositoryService from 'src/services/repositoryService';
import dispatchError from 'src/utils/dispatchError';

export function getRepositories() {
  return async (dispatch) => {
    try {
      const repositories = await repositoryService.allRepositories();
      dispatch({
        type: actionType.GET_ALL_SUCCESS,
        payload: {
          repositories
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to get list of repositories');
    }
  };
}

export function getUserRepositories() {
  return async (dispatch) => {
    try {
      const repositories = await repositoryService.getUserRepositories();
      dispatch({
        type: actionType.GET_USER_SUCCESS,
        payload: {
          repositories
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to get user repository list');
    }
  };
}

export function getRepository(repositoryId) {
  return async (dispatch) => {
    try {
      const repository = await repositoryService.getRepository(repositoryId);
      dispatch({
        type: actionType.GET_SUCCESS,
        payload: {
          repository
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to get repository');
    }
  };
}

export function updateRepository(data) {
  return async (dispatch) => {
    try {
      await repositoryService.updateRepository(data);
      dispatch({
        type: actionType.UPDATE_SUCCESS,
        payload: {
          repository: data,
          successMsg: 'Successfully updated repository information'
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to update repository information');
    }
  };
}

export function clearRepository() {
  return async (dispatch) => {
    dispatch({
      type: actionType.GET_SUCCESS,
      payload: {
        repository: null
      }
    });
  };
}

export function removeMessage() {
  return async (dispatch) => {
    dispatch({
      type: actionType.CLEAR_MESSAGES,
    });
  };
}
